export const UPDATE_STRATEGY_LIST = 'UPDATE_STRATEGY_LIST';
export const SET_STRATEGY = "SET_STRATEGY";
export const SET_SHAREDLIST = 'SET_SHAREDLIST';
export const INSERT_STRATEGYSCORE = "INSERT_STRATEGYSCORE";
export const SET_SIDEBAR_STRATEGY_SCORE_ID = 'SET_SIDEBAR_STRATEGY_SCORE_ID';
export const CLEAR_SPECIFIC_GROUP_IN_TRACKING_STOCK = 'CLEAR_SPECIFIC_GROUP_IN_TRACKING_STOCK';